<template>
  <div>
    <avue-crud
      ref="crud"
      v-model="form"
      :option="option"
      :table-loading="loading"
      :data="data"
      :page.sync="page"
      :search.sync="query"
      :defaults.sync="defaults"
      @search-change="searchChange"
      @search-reset="searchReset"
      @refresh-change="refreshChange"
      @current-change="currentChange"
      @size-change="sizeChange"
      @on-load="onLoad"
    >
      <template slot="menu" slot-scope="{ row }">
        <el-button v-if="row.alertStatus !== 4" type="text" size="small" icon="el-icon-check" @click="handle(row)">
          处理
        </el-button>
      </template>
    </avue-crud>
  </div>
</template>

<script>
import crudMixins from '@/mixins/crud-mixins'
import { getList, handleAlarm } from '@/api/env-monitor/alarm'

export default {
  name: 'env-monitor-alarm',
  mixins: [crudMixins],
  data() {
    return {
      apiConfig: { getList },
      option: {
        ...this.$store.state.publicOption,
        addBtn: false,
        editBtn: false,
        delBtn: false,
        viewBtn: true,
        column: [
          { label: '设备名称', prop: 'deviceName', search: true, minWidth: 150 },
          { label: '提醒类型', prop: 'alertType', width: 110, type: 'select', dicUrl: '/api/blade-system/dict-biz/dictionary?code=alert_type', props: { label: 'dictValue', value: 'dictKey' } },
          { label: '报警状态', prop: 'alertStatus', search: true, width: 110, type: 'select', dicUrl: '/api/blade-system/dict-biz/dictionary?code=alert_status', props: { label: 'dictValue', value: 'dictKey' } },
          { label: '当前值', prop: 'currentValue', minWidth: 100 },
          { label: '阈值', prop: 'thresholdValue', minWidth: 100 },
          { label: '报警时间', prop: 'alertTime', type: 'datetime', format: 'yyyy-MM-dd HH:mm:ss', valueFormat: 'yyyy-MM-dd HH:mm:ss', minWidth: 170 },
          { label: '报警内容', prop: 'alarmContent', minWidth: 240, overHidden: true },
          { label: '处理时间', prop: 'processTime', type: 'datetime', format: 'yyyy-MM-dd HH:mm:ss', valueFormat: 'yyyy-MM-dd HH:mm:ss', minWidth: 170 },
          { label: '处理结果', prop: 'processResult', minWidth: 180, overHidden: true },
          { label: '备注', prop: 'remark', minWidth: 180, overHidden: true }
        ]
      }
    }
  },
  methods: {
    handle(row) {
      this.$prompt('请输入处理结果', '报警处理', {
        inputType: 'textarea',
        inputValue: row.processResult || '人工确认处理',
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(({ value }) => {
        return handleAlarm({
          id: row.id,
          processResult: value
        })
      }).then(() => {
        this.$message.success('操作成功')
        this.onLoad(this.page)
      })
    }
  }
}
</script>
